import { useId } from 'react'
import { ExternalLink, MapPin } from 'lucide-react'
import { cn } from '@/lib/utils'

export const STORE_MAP_URL = 'https://maps.app.goo.gl/vkYxprKqH8sYNuj39?g_st=iw'
const STORE_MAP_EMBED_URL =
  'https://www.google.com/maps?q=2QJJ%2BPGM%20OOUDH%20KRAFT%2C%20Peerbagh%2C%20Srinagar%2C%20Jammu%20and%20Kashmir%20190014&output=embed'

interface StoreLocationMapProps {
  className?: string
}

export function StoreLocationMap({ className }: StoreLocationMapProps) {
  const headingId = useId()

  return (
    <section
      className={cn('mx-auto max-w-4xl', className)}
      aria-labelledby={headingId}
    >
      <div className="mb-4 text-center">
        <p className="type-label text-gold-700">Our location</p>
        <h2
          id={headingId}
          className="mt-1 font-display text-2xl font-semibold text-gold-700"
        >
          Visit OOUDH KRAFT
        </h2>
      </div>

      <div className="overflow-hidden rounded-2xl border border-gold-500/25 bg-white shadow-xl shadow-gold-700/10">
        <iframe
          title="OOUDH KRAFT location on Google Maps"
          src={STORE_MAP_EMBED_URL}
          className="block h-[280px] w-full border-0 sm:h-[340px]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />

        <div className="flex flex-col gap-4 border-t border-gold-500/15 bg-gradient-to-r from-gold-50/80 via-white to-gold-50/60 p-4 sm:flex-row sm:items-center sm:justify-between sm:p-5">
          <div className="flex min-w-0 items-center gap-3">
            <span className="gold-gradient-ring flex h-11 w-11 shrink-0 items-center justify-center rounded-full p-[2px] shadow-sm shadow-gold-500/20">
              <span className="flex h-full w-full items-center justify-center rounded-full bg-white">
                <MapPin className="h-5 w-5 text-gold-700" aria-hidden />
              </span>
            </span>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gold-700">OOUDH KRAFT</p>
              <address className="mt-0.5 text-sm font-medium not-italic leading-relaxed text-gold-700">
                New Airport Road, Main Chowk Peerbagh, Srinagar 190014
              </address>
            </div>
          </div>

          <a
            href={STORE_MAP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary min-h-10 shrink-0 px-4 py-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 focus-visible:ring-offset-2"
          >
            Get directions
            <ExternalLink className="h-4 w-4" aria-hidden />
          </a>
        </div>
      </div>
    </section>
  )
}
